export interface Unit_Interface {
  id:number,
  quantity_id:number,
  quantity_title:String,
  title:String,
  del:boolean,
}

export function Empty_Unit_Interface():Unit_Interface{
  return{
    id:0,
    quantity_id:0,
    title:'',
    quantity_title:'',
    del:false
  }
}
